export const IMAGES = {
  heroFacade:
    "https://images.unsplash.com/photo-1644168819878-d0907cf90a07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxpdGFsaWFuJTIwcm9tYW5lc3F1ZSUyMGdvdGhpYyUyMGNhdGhlZHJhbCUyMGZhY2FkZSUyMHN0b25lJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MTMwMTcwNXww&ixlib=rb-4.1.0&q=85",
  roseWindow:
    "https://images.unsplash.com/photo-1782754569213-7061173564cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxyb3NlJTIwd2luZG93JTIwcm9tYW5lc3F1ZSUyMGNodXJjaCUyMGludGVyaW9yJTIwbmF2ZSUyMHN0b25lJTIwYXJjaGVzfGVufDB8fHx8MTc5MTMwMTcxMnww&ixlib=rb-4.1.0&q=85",
  interiorNave:
    "https://images.unsplash.com/photo-1779119590445-2f5f9dea8f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHxfHxyb3NlJTIwd2luZG93JTIwcm9tYW5lc3F1ZSUyMGNodXJjaCUyMGludGVyaW9yJTIwbmF2ZSUyMHN0b25lJTIwYXJjaGVzfGVufDB8fHx8MTc5MTMwMTcxMnww&ixlib=rb-4.1.0&q=85",
  frescoApocalypse:
    "https://images.unsplash.com/photo-1576016770956-debb63d92058?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxtZWRpZXZhbCUyMGZyZXNjbyUyMHBhaW50aW5nJTIwY2VpbGluZyUyMGFuZ2VscyUyMHJlbmFpc3NhbmNlJTIwYXJ0fGVufDB8fHx8MTc5MTMwMTcxMnww&ixlib=rb-4.1.0&q=85",
  frescoAngels:
    "https://images.pexels.com/photos/37585929/pexels-photo-37585929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  frescoGenesis:
    "https://images.pexels.com/photos/30726093/pexels-photo-30726093.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portalStatue:
    "https://images.unsplash.com/photo-1744540135001-a5c7eff416ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwcm9tYW5lc3F1ZSUyMGdvdGhpYyUyMGNhdGhlZHJhbCUyMGZhY2FkZSUyMHN0b25lJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MTMwMTcwNXww&ixlib=rb-4.1.0&q=85",
  chiostro:
    "https://images.unsplash.com/photo-1765646846614-24b72adbaf4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxtZWRpZXZhbCUyMGNsb2lzdGVyJTIwc3RvbmUlMjBhcmNoZXMlMjBjb2x1bW5zJTIwaXRhbGlhbnxlbnwwfHx8fDE3OTEzMDE4Mjl8MA&ixlib=rb-4.1.0&q=85",
  abside:
    "https://images.unsplash.com/photo-1723665701625-73ef9fd0061b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwcm9tYW5lc3F1ZSUyMGdvdGhpYyUyMGFwc2UlMjBjaHVyY2glMjBleHRlcmlvciUyMHN0b25lfGVufDB8fHx8MTc5MTMwMTgyOXww&ixlib=rb-4.1.0&q=85",
  dettaglio:
    "https://images.unsplash.com/photo-1763026511387-0d87685dc64d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxjb2x1bW4lMjBjYXBpdGFsJTIwc3RvbmV8ZW58MHx8fHwxNzkxMzAxODQ2fDA&ixlib=rb-4.1.0&q=85",
  portale:
    "https://images.unsplash.com/photo-1668807764357-79004646bc85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxjaHVyY2glMjBwb3J0YWwlMjBzdG9uZXxlbnwwfHx8fDE3OTEzMDE4NDZ8MA&ixlib=rb-4.1.0&q=85",
  affrescoDettaglio:
    "https://images.unsplash.com/photo-1780586876169-37e6e354c549?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxtZWRpZXZhbCUyMGZyZXNjbyUyMGRldGFpbCUyMHBhaW50aW5nJTIwZmlndXJlJTIwd2FybSUyMHRvbmVzfGVufDB8fHx8MTc5MTMwMTgzNXww&ixlib=rb-4.1.0&q=85",
  volta:
    "https://images.unsplash.com/photo-1780586803344-df1b8fb5f1f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxmcmVzY28lMjBjZWlsaW5nJTIwdmF1bHQlMjBtZWRpZXZhbCUyMGNodXJjaCUyMGludGVyaW9yfGVufDB8fHx8MTc5MTMwMTgzNXww&ixlib=rb-4.1.0&q=85",
  pietraLeccese:
    "https://images.unsplash.com/photo-1584455897701-ed108e1e4eaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MDV8MHwxfHNlYXJjaHwyfHxsaW1lc3RvbmUlMjB0ZXh0dXJlJTIwd2FybSUyMGNodXJjaCUyMGZhY2FkZSUyMGdvbGRlbiUyMGhvdXJ8ZW58MHx8fHwxNzkxMzAxODM1fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_SECTIONS = [
  { id: "home", label: "Home" },
  { id: "storia", label: "Storia" },
  { id: "architettura", label: "Architettura" },
  { id: "affreschi", label: "Gli Affreschi" },
  { id: "opere", label: "Le Opere e i Tesori" },
  { id: "oggi", label: "La Basilica Oggi" },
  { id: "galleria", label: "Galleria" },
];

export const TIMELINE = [
  {
    year: "1369",
    century: "XIV",
    title: "L'inizio della costruzione",
    short:
      "Secondo la tradizione storiografica, i lavori di costruzione della chiesa prendono avvio intorno al 1369.",
    detail:
      "La data del 1369 è tramandata dalla tradizione: la documentazione superstite non permette di stabilirla con certezza assoluta. Il cantiere è legato alla volontà di Raimondello Orsini del Balzo, una delle figure più potenti del Regno di Napoli del suo tempo.",
  },
  {
    year: "1383",
    century: "XIV",
    title: "La committenza di Raimondello",
    short:
      "Il 1383 è tradizionalmente associato a una fase importante del cantiere, promossa da Raimondello Orsini del Balzo.",
    detail:
      "Raimondello, conte di Soleto, era marito di Maria d'Enghien, contessa di Lecce. La sua committenza trasforma il cantiere di Galatina in un cantiere di rango principesco: maestranze, materiali pregiati e un progetto architettonico ambizioso.",
  },
  {
    year: "1391",
    century: "XIV",
    title: "Il completamento",
    short:
      "La tradizione colloca nel 1391 il completamento della costruzione della chiesa.",
    detail:
      "Anche questa data va accolta con cautela: gli studiosi la indicano come datazione tradizionale. Ciò che è certo è che alla fine del Trecento l'edificio era ormai definito nella sua impostazione romanico-gotica.",
  },
  {
    year: "XV secolo",
    century: "XV",
    title: "La grande stagione degli affreschi",
    short:
      "Nel corso del Quattrocento l'interno viene coperto da un vastissimo ciclo pittorico.",
    detail:
      "La decorazione fu promossa dalla famiglia Orsini del Balzo — da Maria d'Enghien, dopo la morte di Raimondello (1406), fino al figlio Giovanni Antonio, principe di Taranto — insieme ai Frati Minori, a cui la chiesa era affidata. Vi lavorarono più botteghe, legate alla cultura giottesca e alla pittura angioina.",
  },
  {
    year: "c. 1460",
    century: "XV",
    title: "Il coro e l'abside ottagonale",
    short:
      "Intorno al 1460, secondo la ricostruzione più accreditata, vengono aggiunti il coro e l'abside di forma ottagonale.",
    detail:
      "L'abside ottagonale chiude l'edificio a oriente con un elemento di grande originalità, che dialoga con l'architettura tardogotica del Regno di Napoli.",
  },
  {
    year: "1870",
    century: "XIX",
    title: "Monumento nazionale",
    short:
      "Nel 1870 la chiesa viene dichiarata monumento nazionale.",
    detail:
      "È il riconoscimento ufficiale del valore artistico e storico dell'edificio, da quel momento tutelato come patrimonio della nazione.",
  },
  {
    year: "1992",
    century: "XX",
    title: "Basilica minore",
    short:
      "Nel 1992 papa Giovanni Paolo II eleva la chiesa alla dignità di basilica minore.",
    detail:
      "Il titolo conferma l'importanza religiosa e culturale di Santa Caterina d'Alessandria, ancora oggi luogo di culto attivo officiato dai Frati Minori Francescani.",
  },
];

export const ARCH_CARDS = [
  {
    id: "facciata",
    icon: "Landmark",
    image: IMAGES.pietraLeccese,
    title: "La facciata romanica",
    brief:
      "Compatta e luminosa, è tra gli esempi più raffinati del romanico pugliese.",
    detail:
      "La facciata, realizzata in pietra leccese e pietra gentile, presenta l'impianto tipico del romanico pugliese: superfici ampie e misurate, lesene che scandiscono il fronte, portali strombati e un grande rosone centrale. La decorazione scolpita — archetti, intrecci, figure — trasforma la pietra dorata in un racconto per immagini.",
  },
  {
    id: "cuspidi",
    icon: "Triangle",
    image: null,
    title: "Le tre cuspidi",
    brief:
      "Tre cuspidi coronano il fronte, riprendendo il ritmo delle navate interne.",
    detail:
      "Il coronamento a tre cuspidi riflette all'esterno l'articolazione interna dell'edificio e alleggerisce la mole della facciata con un movimento ascendente. È un motivo che si ritrova in altre grandi chiese pugliesi del periodo angioino.",
  },
  {
    id: "portali",
    icon: "DoorOpen",
    image: IMAGES.portale,
    title: "I tre portali",
    brief:
      "Portali strombati con colonnine, capitelli e lunette scolpite.",
    detail:
      "Tre portali introducono all'interno: quello centrale, più ampio e più ricco, è incorniciato da ghigliottine e da archetti concentrici che si susseguono verso la lunetta. La strombatura — l'apertura che si allarga verso l'esterno — è un segno distintivo del romanico.",
  },
  {
    id: "rosone",
    icon: "CircleDot",
    image: IMAGES.roseWindow,
    title: "Il rosone centrale",
    brief:
      "Il cuore luminoso della facciata: una raggiera di pietra che filtra la luce.",
    detail:
      "Il rosone domina il centro della facciata e illumina la navata principale. La sua trama di colonnine e archetti trasforma la luce del sole in un elemento architettonico: di giorno proietta all'interno un disegno luminoso in continuo cambiamento.",
  },
  {
    id: "pietra",
    icon: "Gem",
    image: IMAGES.dettaglio,
    title: "La pietra leccese",
    brief:
      "Un calcare tenero e dorato, facile da scolpire: la materia dell'architettura salentina.",
    detail:
      "La pietra leccese è un calcare tenero e compatto, dal colore caldo che va dal miele all'ambra. Proprio perché si lascia scolpire con facilità, ha reso possibile la fittissima decorazione di portali, capitelli e cornici. Con il tempo assume una patina dorata che rende l'edificio quasi luminoso al tramonto.",
  },
  {
    id: "gotico",
    icon: "ArrowUpNarrowWide",
    image: null,
    title: "Gli elementi gotici",
    brief:
      "Arcate ogivali, slancio verticale e volte a crociera: il linguaggio angioino.",
    detail:
      "Accanto all'impianto romanico, la Basilica parla la lingua del gotico angioino: archi a sesto acuto, volte a crociera, un nuovo senso della verticalità. Sono i segni del legame tra la committenza Orsini del Balzo e la corte angioina di Napoli.",
  },
  {
    id: "abside",
    icon: "Octagon",
    image: IMAGES.abside,
    title: "Coro e abside ottagonale",
    brief:
      "Aggiunti intorno al 1460, chiudono l'edificio a oriente con un gesto originale.",
    detail:
      "La parte terminale della chiesa — coro e abside di forma ottagonale — risale, secondo la ricostruzione più accreditata, a intorno al 1460. La pianta ottagonale, rara in Puglia, avvicina l'edificio alle esperienze tardogotiche del Regno di Napoli.",
  },
  {
    id: "interno",
    icon: "Columns3",
    image: IMAGES.interiorNave,
    title: "Navate, volte, colonne e capitelli",
    brief:
      "L'interno è suddiviso in cinque navate coperte da volte a crociera.",
    detail:
      "L'aula interna è divisa in cinque navate da file di colonne con capitelli scolpiti, che sostengono le volte a crociera. Su questa struttura si distende il grande ciclo di affreschi: ogni vela, ogni parete, ogni arco diventa pagina dipinta.",
  },
];

export const ROMANICO = [
  "Facciata compatta coronata da cuspidi",
  "Portali strombati con lunette scolpite",
  "Il rosone scavato nella pietra",
  "Muratura in pietra leccese dorata",
  "Solidità, misura e simmetria",
  "Echi delle culture normanna e bizantina",
];

export const GOTICO = [
  "Arcate a sesto acuto (ogive)",
  "Volte a crociera nelle navate",
  "Slancio verticale e leggerezza",
  "Grande decorazione pittorica di corte",
  "Legami con la Napoli angioina",
  "Eleganza della linea e del dettaglio",
];

export const FRESCHI = [
  {
    id: "apocalisse",
    image: IMAGES.frescoApocalypse,
    title: "L'Apocalisse",
    period: "Prima metà del XV secolo",
    place: "Volte delle navate",
    brief:
      "Visioni del libro di Giovanni: il giudizio finale dipinto sopra le teste dei fedeli.",
    detail:
      "Le vele delle volte ospitano scene dell'Apocalisse secondo Giovanni: un programma teologico grandioso, pensato per essere letto dal basso, che trasforma il soffitto della chiesa in un cielo narrativo.",
  },
  {
    id: "genesiss",
    image: IMAGES.frescoGenesis,
    title: "Le Storie della Genesi",
    period: "Prima metà del XV secolo",
    place: "Pareti e campate dell'aula",
    brief:
      "Dalla creazione del mondo alle vicende dei patriarchi: l'inizio della storia sacra.",
    detail:
      "Il racconto dipinto comincia dalle origini: le scene della Genesi introducono il fedele alla storia della salvezza, in un percorso che si svolge lungo le pareti e le campate dell'edificio.",
  },
  {
    id: "cristologico",
    image: IMAGES.volta,
    title: "Il ciclo cristologico",
    period: "XV secolo",
    place: "Navate dell'aula",
    brief:
      "Gli episodi della vita di Cristo, cuore di ogni decorazione sacra medievale.",
    detail:
      "Le storie della vita di Gesù costituiscono il fulcro del programma pittorico: nascita, predicazione, passione e risurrezione si susseguono in una narrazione pensata per una comunità che imparava la fede attraverso le immagini.",
  },
  {
    id: "caterina",
    image: IMAGES.affrescoDettaglio,
    title: "Le Storie di Santa Caterina",
    period: "XV secolo",
    place: "All'interno dell'edificio",
    brief:
      "Gli episodi della vita della santa a cui la Basilica è dedicata.",
    detail:
      "Caterina d'Alessandria — giovane sapiente, martire sotto l'imperatore Massenzio — è la protagonista di un ciclo dedicato: la disputa con i dotti, il supplizio della ruota, il martirio. Una scelta legata alla devozione personale di Raimondello Orsini del Balzo.",
  },
  {
    id: "angeli",
    image: IMAGES.frescoAngels,
    title: "Gli Angeli musicanti",
    period: "XV secolo",
    place: "Vele delle volte",
    brief:
      "Un'intera orchestra celeste: angeli che suonano gli strumenti del Medioevo.",
    detail:
      "Nelle vele delle volte gli angeli suonano liuto, arpa, viella, organo portativo, salterio, cornamusa e percussioni: una raffigurazione così accurata da essere studiata dagli storici della musica come documento sugli strumenti medievali.",
  },
  {
    id: "santi",
    image: IMAGES.interiorNave,
    title: "Santi, Evangelisti e Dottori",
    period: "XV secolo",
    place: "Pareti, archi e vele",
    brief:
      "Un'intera comunità di figure sacre popola ogni superficie disponibile.",
    detail:
      "Intorno ai grandi cicli si dispone una folla di santi, evangelisti, profeti e dottori della Chiesa: figure a tutta figura o a mezzo busto che accompagnano il visitatore come in un grande libro illustrato.",
  },
];

export const STRUMENTI = [
  "Liuto",
  "Arpa",
  "Viella",
  "Organo portativo",
  "Salterio",
  "Cornamusa",
  "Tamburello",
  "Nacchere",
];

export const OPERE = [
  {
    id: "reliquia",
    badge: "Tradizione",
    title: "Il dito di Santa Caterina",
    text:
      "Secondo la tradizione, la Basilica custodisce una reliquia del corpo di Santa Caterina d'Alessandria: un dito della santa, venerato per secoli dai fedeli di Galatina e del Salento.",
  },
  {
    id: "viaggio",
    badge: "Leggenda",
    title: "Il viaggio di Raimondello",
    text:
      "Il racconto leggendario narra che Raimondello Orsini del Balzo, in pellegrinaggio al monastero di Santa Caterina sul Monte Sinai, baciando la mano incorrotta della santa ne staccò con i denti un dito, che portò con sé in Terra d'Otranto. È un racconto devozionale non documentato, ma testimonia quanto fosse viva la devozione medievale verso la santa d'Alessandria.",
  },
  {
    id: "ciclo",
    badge: "Documentato",
    title: "Il ciclo affrescato",
    text:
      "Il vero tesoro della Basilica è il suo apparato pittorico: uno dei cicli di affreschi più estesi del Medioevo italiano, realizzato nel corso del Quattrocento da più botteghe. Le fonti non consentono di attribuirlo con certezza a singoli artisti.",
  },
  {
    id: "coro",
    badge: "Documentato",
    title: "Il coro e l'abside",
    text:
      "Il coro e l'abside ottagonale, aggiunti intorno al 1460 secondo la ricostruzione più accreditata, sono tra gli elementi architettonici più originali dell'edificio.",
  },
  {
    id: "chiostro",
    badge: "Documentato",
    title: "Il convento francescano",
    text:
      "Accanto alla chiesa sorge il convento dei Frati Minori, con il suo chiostro: la presenza francescana, legata alla storia della Basilica fin dalle origini, continua ancora oggi.",
  },
];

export const GALLERY = [
  { image: IMAGES.heroFacade, title: "La facciata", caption: "Il fronte romanico in pietra leccese" },
  { image: IMAGES.roseWindow, title: "Il rosone", caption: "La luce filtrata dalla pietra scolpita" },
  { image: IMAGES.portalStatue, title: "I portali", caption: "Strombature e sculture dei tre ingressi" },
  { image: IMAGES.interiorNave, title: "L'interno", caption: "Le cinque navate verso il presbiterio" },
  { image: IMAGES.volta, title: "Gli affreschi", caption: "Il grande ciclo pittorico del Quattrocento" },
  { image: IMAGES.abside, title: "Coro e abside", caption: "L'abside ottagonale, intorno al 1460" },
  { image: IMAGES.dettaglio, title: "Dettagli in pietra", caption: "Capitelli e rilievi in pietra leccese" },
  { image: IMAGES.chiostro, title: "Il chiostro", caption: "Il convento dei Frati Minori" },
];

export const FONTI = [
  {
    name: "Ministero della Cultura — Catalogo Generale dei Beni Culturali",
    desc: "Schede catalografiche ufficiali del patrimonio culturale italiano.",
    url: "https://catalogo.beniculturali.it",
  },
  {
    name: "Regione Puglia — Viaggiare in Puglia",
    desc: "Il portale istituzionale del turismo della Regione Puglia.",
    url: "https://www.viaggiareinpuglia.it",
  },
  {
    name: "Sito ufficiale della Basilica — Basilica Orsiniana",
    desc: "La parrocchia di Santa Caterina d'Alessandria: storia, visite e vita della Basilica.",
    url: "https://www.basilicaorsiniana.it",
  },
  {
    name: "Comune di Galatina",
    desc: "Le schede dei luoghi storici sul portale istituzionale della città.",
    url: "https://www.comune.galatina.le.it",
  },
  {
    name: "Università degli Studi di Bari \"Aldo Moro\"",
    desc: "Studi e ricerche sull'architettura e la pittura medievale pugliese.",
    url: "https://www.uniba.it",
  },
  {
    name: "Arcidiocesi di Otranto",
    desc: "Annuario diocesano e informazioni sulla parrocchia di Santa Caterina.",
    url: "https://www.diocesiotranto.it",
  },
];

export const VISIT = {
  place: "Galatina, provincia di Lecce — Puglia",
  address: "Piazza Orsini · Centro storico, 73013 Galatina (LE)",
  hours: "Verificare gli orari prima della visita",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Basilica+di+Santa+Caterina+d%27Alessandria+Galatina",
  officialUrl: "https://www.basilicaorsiniana.it",
  osmEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=18.1594%2C40.1689%2C18.1794%2C40.1789&layer=mapnik&marker=40.1739%2C18.1694",
};
